import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import {
  IconButton,
  useMediaQuery
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useTheme } from '@mui/system';
import ListItem from './list-item';
import DeviceInfo from './device-info';
import propTypes from './prop-types';
import DeviceListMobile from './device-list-mobile';
import {
  ListHeaderCnt,
  Title,
  CloseListCnt,
  CloseListBtn,
  ListCnt,
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
  LinkShowAll,
  Divider
} from './styles';

const DeviceList = props => {
  const theme = useTheme();
  const meta = useSelector(s => s.meta, shallowEqual);
  const { account, devices, closeList, uids } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    !isMobile ?
      <>
        <ListHeaderCnt>
          <CloseListCnt>
            <CloseListBtn
              aria-label="Close"
              onClick={() => closeList([])}
            >
              <CloseRoundedIcon fontSize="small" />
            </CloseListBtn>
          </CloseListCnt>
          <Title className="listTitle">Devices</Title>
        </ListHeaderCnt>
        <Divider />
        <ListCnt>
          {devices.map(device => (
            <StyledAccordion
              TransitionProps={{
                timeout: { appear: 0, enter: 500, exit: 150 }
              }}
              key={device.id}
              square
              defaultExpanded={devices.length === 1}
            >
              <StyledAccordionSummary
                expandIcon={
                  devices.length === 1 ? null :
                  <IconButton>
                    <ExpandMoreIcon />
                  </IconButton>
                }
              >
                <ListItem
                  key={device.id}
                  device={device}
                />
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <DeviceInfo
                  theme={theme}
                  account={account}
                  device={device}
                  meta={meta}
                />
              </StyledAccordionDetails>
            </StyledAccordion>
          ))}
          <Divider />
          {uids?.length > 100 ?
            <LinkShowAll
              to="/device"
            >
              <span>Show all devices</span>
            </LinkShowAll> : null}
        </ListCnt>
      </> :
      <DeviceListMobile
        account={props.account}
        devices={props.devices}
        closeList={props.closeList}
        uids={props.uids}
      />
  );
};

DeviceList.propTypes = propTypes;

export default DeviceList;
